import React from 'react';
import { T } from './NOCShared';

export function CircularGauge({ value, max = 100, size = 90, strokeWidth = 6, label, unit = '%', subLabel, color1 = T.pink, color2 = T.purple }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const pct = Math.min(Math.max(value / max, 0), 1);
  const dashoffset = circumference * (1 - pct);
  const gradId = `gaugeGrad_${label?.replace(/\s/g, '_') || Math.random()}`;

  const barColor = value > 90 ? T.danger : value > 70 ? T.warning : `url(#${gradId})`;
  const glowColor = value > 90 ? T.danger : T.purple;

  return (
    <div className="flex flex-col items-center">
      <svg width={size} height={size} className="transform -rotate-90">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={color1} />
            <stop offset="100%" stopColor={color2} />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke="rgba(255,255,255,0.06)" strokeWidth={strokeWidth} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none"
          stroke={barColor} strokeWidth={strokeWidth} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={dashoffset}
          style={{ filter: `drop-shadow(0 0 6px ${glowColor}50)`, transition: 'stroke-dashoffset 0.8s ease' }} />
      </svg>
      <div className="text-center" style={{ marginTop: `-${size / 2 + 8}px`, position: 'relative', zIndex: 1 }}>
        <div className="font-mono text-base font-bold" style={{ color: T.textBright }}>{Math.round(value)}{unit}</div>
        {label && <div className="text-[9px] tracking-wider uppercase" style={{ color: T.textDim }}>{label}</div>}
        {subLabel && <div className="text-[8px]" style={{ color: T.purple }}>{subLabel}</div>}
      </div>
    </div>
  );
}

export function MiniGauge({ value, label, size = 52, strokeWidth = 4 }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const pct = Math.min(Math.max(value / 100, 0), 1);
  const dashoffset = circumference * (1 - pct);
  return (
    <div className="flex flex-col items-center gap-0.5">
      <svg width={size} height={size} className="transform -rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={strokeWidth} />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="url(#miniGaugeGrad)" strokeWidth={strokeWidth} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={dashoffset}
          style={{ filter: `drop-shadow(0 0 3px ${T.purple}40)`, transition: 'stroke-dashoffset 0.6s ease' }} />
        <defs>
          <linearGradient id="miniGaugeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={T.pink} />
            <stop offset="100%" stopColor={T.purple} />
          </linearGradient>
        </defs>
      </svg>
      <span className="font-mono text-[10px] font-bold" style={{ color: T.textBright }}>{Math.round(value)}%</span>
      <span className="text-[7px] uppercase tracking-wider" style={{ color: T.textDim }}>{label}</span>
    </div>
  );
}
